import { Pipe, PipeTransform } from '@angular/core';
import { CONFIG } from '../constants/config.constants';
import * as _ from 'lodash';

@Pipe({
  name: 'idToKeyConfigPipe'
})
export class IdToKeyConfigPipe implements PipeTransform {
  transform(id: number, property: string): any {
    const item = _.find(CONFIG[property], {
    	'id': id
    });

    if (item) {
    	return item.key;
    }
  }
}
